module.exports = __webpack_public_path__ + "img/JAOC_POP_TomatoSauce_rectangular.3cc9aaa1.png";